import styled from "styled-components";
import Colors from "../../constants/Colors";

export const ModalContainer = styled.div<{isMobile?: boolean}>`
    border-radius: 8px;
    justify-content: center;
    text-align: center;
    align-items: center;
    align-self: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: ${props=>props.isMobile? '300px':'400px'};
    height: ${props=>props.isMobile? '350px':'300px'};
    background-color: ${Colors.SPM600};
`
export const ModalContentContainer = styled.div<{isMobile?: boolean}>`
    margin-top: ${props=>props.isMobile? '15%':'5%'};
    margin-left: ${props=>props.isMobile? '15%':'5%'};
    margin-right: ${props=>props.isMobile? '15%':'5%'};
`
export const ButtonAreaContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`